<template>
  <div class="wireless-box-bar" type="flex">
    <el-row type="flex" class="overall-status" justify="end">
      <!-- <el-col tag="span" :span="3">
        <span class="iconfont icon-humidity2"></span>
        {{ $t('湿度') }}：{{ humidity }}%
      </el-col>
      <el-col tag="span" :span="3">
        <span class="iconfont icon-temperature2"></span>
        {{ $t('温度') }}：{{ temp }}℃
      </el-col> -->

      <!-- <el-col tag="span" :span="4" v-if="radonConcentrationError">
        浓度误差值(Bq/m³)：
        <span>{{ radonConcentrationError }}</span> 
      </el-col> -->
      <el-col tag="span" :span="3">
        {{ $t('报警状态') }}：
        <span :class="alarmStatus | alarmClass">{{ alarmStatus | alarmText }}</span>
      </el-col>
      <el-col tag="span" :span="3">
        {{ $t('运行状态') }}：
        <span :class="runState | runClass">{{ runState | runText }}</span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { tools } from '../utils';
import { isEmpty } from '@/utils/is';

export default {
  props: {
    alarmStatus: {
      type: Number,
      default: 0
    },
    runState: {
      type: Number,
      default: 0
    }
  },
  filters: tools,
  methods: {
    isEmpty
  }
};
</script>

<style lang="scss">
.wireless-box-bar {
  margin-bottom: 20px;

  .iconfont {
    font-size: 20px;
    color: $normal-color;
  }

  //   .common-border2 {
  //     border: 1px solid rgb(96, 118, 173);
  //   }

  //   .common-border {
  //     height: 100%;
  //     padding: 2px;
  //     background-image: url('~@/assets/image/lt.png'), url('~@/assets/image/rt.png'),
  //       url('~@/assets/image/lb.png'), url('~@/assets/image/rb.png'),
  //       url('~@/assets/image/linelight.png');
  //     background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
  //     background-position: top left, top right, bottom left, bottom right, center -5px;

  //     .comp3-content {
  //       height: 100%;
  //       box-sizing: border-box;
  //     }
  //   }

  //   .pump-status {
  //     height: 50px;
  //   }
  .overall-status {
    font-weight: bold;
    span {
      @include state-textstyle;
    }
  }
  .el-col {
    font-size: 18px;
    padding-left: 20px;
    text-align: center;
  }
}
</style>
